export default __webpack_public_path__ + "static/media/Sit2GetherLogo.b228f97a.png";